export default __webpack_public_path__ + "static/media/img1.5f86e300.jpg";